export default __webpack_public_path__ + "static/media/Arrow_right.58f0c648.svg";